import { TOGGLE_ALERT } from "./alertboxAction";

const initialState = {
  isAlertOn: false,
  message: ""
};

export default function(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_ALERT:
      console.log('in TOGGLE_ALERT');
      console.log(state.isAlertOn);
      return {
        ...state,
        isAlertOn: !state.isAlertOn,
        message: action.payload
      };
    default:
      return state;
  }
}
